export const subregions_en = {
    "Northern Africa": [
        "DZA",
        "EGY",
        "LBY",
        "MAR",
        "SDN",
        "TUN",
        "ESH"
    ],
    "Sub-Saharan Africa": [
        "IOT",
        "BDI",
        "COM",
        "DJI",
        "ERI",
        "ETH",
        "ATF",
        "KEN",
        "MDG",
        "MWI",
        "MUS",
        "MYT",
        "MOZ",
        "REU",
        "RWA",
        "SYC",
        "SOM",
        "SSD",
        "UGA",
        "TZA",
        "ZMB",
        "ZWE",
        "AGO",
        "CMR",
        "CAF",
        "TCD",
        "COG",
        "COD",
        "GNQ",
        "GAB",
        "STP",
        "BWA",
        "SWZ",
        "LSO",
        "NAM",
        "ZAF",
        "BEN",
        "BFA",
        "CPV",
        "CIV",
        "GMB",
        "GHA",
        "GIN",
        "GNB",
        "LBR",
        "MLI",
        "MRT",
        "NER",
        "NGA",
        "SHN",
        "SEN",
        "SLE",
        "TGO"
    ],
    "Latin America and the Caribbean": [
        "AIA",
        "ATG",
        "ABW",
        "BHS",
        "BRB",
        "BES",
        "VGB",
        "CYM",
        "CUB",
        "CUW",
        "DMA",
        "DOM",
        "GRD",
        "GLP",
        "HTI",
        "JAM",
        "MTQ",
        "MSR",
        "PRI",
        "BLM",
        "KNA",
        "LCA",
        "MAF",
        "VCT",
        "SXM",
        "TTO",
        "TCA",
        "VIR",
        "BLZ",
        "CRI",
        "SLV",
        "GTM",
        "HND",
        "MEX",
        "NIC",
        "PAN",
        "ARG",
        "BOL",
        "BVT",
        "BRA",
        "CHL",
        "COL",
        "ECU",
        "FLK",
        "GUF",
        "GUY",
        "PRY",
        "PER",
        "SGS",
        "SUR",
        "URY",
        "VEN"
    ],
    "Northern America": [
        "BMU",
        "CAN",
        "GRL",
        "SPM",
        "USA"
    ],
    "Central Asia": [
        "KAZ",
        "KGZ",
        "TJK",
        "TKM",
        "UZB"
    ],
    "Eastern Asia": [
        "CHN",
        "HKG",
        "MAC",
        "PRK",
        "JPN",
        "MNG",
        "KOR"
    ],
    "South-eastern Asia": [
        "BRN",
        "KHM",
        "IDN",
        "LAO",
        "MYS",
        "MMR",
        "PHL",
        "SGP",
        "THA",
        "TLS",
        "VNM"
    ],
    "Southern Asia": [
        "AFG",
        "BGD",
        "BTN",
        "IND",
        "IRN",
        "MDV",
        "NPL",
        "PAK",
        "LKA"
    ],
    "Western Asia": [
        "ARM",
        "AZE",
        "BHR",
        "CYP",
        "GEO",
        "IRQ",
        "ISR",
        "JOR",
        "KWT",
        "LBN",
        "OMN",
        "QAT",
        "SAU",
        "PSE",
        "SYR",
        "TUR",
        "ARE",
        "YEM"
    ],
    "Eastern Europe": [
        "BLR",
        "BGR",
        "CZE",
        "HUN",
        "POL",
        "MDA",
        "ROU",
        "RUS",
        "SVK",
        "UKR"
    ],
    "Northern Europe": [
        "ALA",
        "GGY",
        "JEY",
        "DNK",
        "EST",
        "FRO",
        "FIN",
        "ISL",
        "IRL",
        "IMN",
        "LVA",
        "LTU",
        "NOR",
        "SJM",
        "SWE",
        "GBR"
    ],
    "Southern Europe": [
        "ALB",
        "AND",
        "BIH",
        "HRV",
        "GIB",
        "GRC",
        "VAT",
        "ITA",
        "MLT",
        "MNE",
        "MKD",
        "PRT",
        "SMR",
        "SRB",
        "SVN",
        "ESP"
    ],
    "Western Europe": [
        "AUT",
        "BEL",
        "FRA",
        "DEU",
        "LIE",
        "LUX",
        "MCO",
        "NLD",
        "CHE"
    ],
    "Australia and New Zealand": [
        "AUS",
        "CXR",
        "CCK",
        "HMD",
        "NZL",
        "NFK"
    ],
    "Melanesia": [
        "FJI",
        "NCL",
        "PNG",
        "SLB",
        "VUT"
    ],
    "Micronesia": [
        "GUM",
        "KIR",
        "MHL",
        "FSM",
        "NRU",
        "MNP",
        "PLW",
        "UMI"
    ],
    "Polynesia": [
        "ASM",
        "COK",
        "PYF",
        "NIU",
        "PCN",
        "WSM",
        "TKL",
        "TON",
        "TUV",
        "WLF"
    ]
};